// admin/active-campaign routes — auto-collected by compose-routes-plugin.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const ActiveCampaignPage = lazyWithRetry(
  () => import("./pages/ActiveCampaignPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/active-campaign", Component: ActiveCampaignPage },
    ],
  },
];

export default routes;
